import React from "react"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"

import Inner from "../../../dsm/layout/Inner"

///////////////////////////////////////
// 🛠 Component
///////////////////////////////////////
const QuoteLayoutB = ({
  text,
  author,
  alignment,
  vSpacing,
  textColour,
  iconColour,
  contentLayout,
  backgroundColour,
  backgroundImage,
  colorHasPriority,
  isPreview,
}) => {
  // Determine if we need a wrapper for a background color or image
  let Wrapper = WrapperColor
  let wrapperProps = {}
  // if local page has a background colour override global image
  if (colorHasPriority) {
    wrapperProps = {
      backgroundColour: backgroundColour,
    }
  } else {
    Wrapper = WrapperImage
    wrapperProps = isPreview
      ? { background: `background: url(${isPreview});`, as: "div" }
      : {
          fluid: backgroundImage.imageFile.childImageSharp.fluid,
        }
  }
  const classes = [contentLayout, "quote"]

  return (
    <Wrapper {...wrapperProps}>
      <Section
        vSpacing={vSpacing}
        alignment={alignment}
        textColour={textColour}
        iconColour={iconColour}
        contentLayout={contentLayout}
        className={classes.join(" ")}
      >
        <Inner>
          <div className="quote-wrapper">
            <h2 dangerouslySetInnerHTML={{ __html: text }} className="text" />
            <div
              dangerouslySetInnerHTML={{ __html: author }}
              className="author"
            />
          </div>
        </Inner>
      </Section>
    </Wrapper>
  )
}
export default QuoteLayoutB

///////////////////////////////////////
// 💅 Styles
///////////////////////////////////////
const WrapperImage = styled(BackgroundImage)`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  ${({ background }) => background}
`
const WrapperColor = styled.div`
  background-color: ${({ backgroundColour }) => backgroundColour};
`
const Section = styled.section`
  padding: ${({ vSpacing }) => `${vSpacing} 0`};
  color: ${({ textColour }) => textColour};
  &.full {
    .inner {
      max-width: ${({ theme }) => theme.maxWidth};
    }
  }
  &.skinny {
    .inner {
      max-width: ${({ theme }) => theme.maxWidthSkinny};
    }
  }
  .inner {
    display: grid;
    justify-content: ${({ alignment }) => alignment};
  }
  .quote-wrapper {
    text-align: ${({ alignment }) =>
      alignment === "flex-start" ? "left" : "center"};
    h2 {
      color: ${({ textColour }) => textColour};
      margin: 0;
      line-height: 1.1;
      quotes: "“" "”" "‘" "’";
      &::before {
        content: open-quote;
        padding-right: 5px;
        color: ${({ iconColour }) => iconColour};
      }
      &::after {
        content: close-quote;
        padding-left: 5px;
        color: ${({ iconColour }) => iconColour};
      }
    }
    .author {
      color: ${({ textColour }) => `${textColour}CC`};
      margin-top: 10px;
      font-size: 1.15rem;
    }
  }
`
